import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '@/lib/axios';
import { DashboardProps } from '@/containers/dashboard/Dashboard';
import {useLoadingStore} from '@/stores/loading';
import {useMessageModalStore} from '@/stores/message'
import DashboardCard from './DashboardCard';
import * as Config from '@/config'

interface SummaryData {
  name?: string;
  count: number;
}

const SaleApply: React.FC<DashboardProps> = ({ projectId, startDate, endDate }) => {
  const setLoading = useLoadingStore(state => state.setLoading);
  const setMessage = useMessageModalStore(state => state.setMessage);

  const [summarySaleApply, setSummarySaleApply] = useState<SummaryData[]>([]);

  const fetchData = useCallback(async (projectCategoryId: number): Promise<SummaryData[]> => {
    const response = await axios.get(`/api/v1/dashboard/dataSummary`, {
      params: {
        project_id: projectId,
        project_category_id: projectCategoryId,
        start_date: startDate,
        end_date: endDate,
      },
    });
    return response.data.summary;
  }, [projectId, startDate, endDate]);

  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      try {
        const [saleApplyData] = await Promise.all([
          fetchData(Config.PROJECT_CATEGORY_ID_SALE_APPLY),
        ]);

        setSummarySaleApply(saleApplyData);

      } catch (err) {
        setMessage(Config.MESSAGE_NO_E39);
      } finally {
        setLoading(false);
      }
    };

    loadAllData();
  }, [fetchData, setLoading]);

  return (
    <div className="dashboard-grid">
      {summarySaleApply.length > 0 &&
        <DashboardCard title='申込の登録数'>
          <table>
            <tbody>
              {summarySaleApply.map((summary, index) => (
                <tr key={`summary_apply_${index}`}>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      }
    </div>
  );
};

export default SaleApply;